module.exports = __webpack_public_path__ + "img/ch16_21_机械臂失控.dded77ac.jpg";